module.exports = Promise.all([parcelRequire.load("aW7bM"), parcelRequire.load("ihb8B"), parcelRequire.load("fnw8b")]).then(() => parcelRequire('6sPw1'));